import { styled } from 'baseui'
import type { Theme } from 'baseui'
import type { SaveStatusKey } from './useClientSaveStatus'

const toneOf = ($theme: Theme, statusKey: SaveStatusKey) => {
  if (statusKey === 'unsaved') return { background: $theme.colors.dangerPulseBg, color: $theme.colors.dangerPulseText }
  if (statusKey === 'saved') return { background: $theme.colors.chipOkBg, color: $theme.colors.chipOkText }
  if (statusKey === 'saving') return { background: $theme.colors.white, color: $theme.colors.primaryPulse }
  return { background: $theme.colors.white, color: $theme.colors.textPulseMuted }
}

export const StatusText = styled<'span', { $statusKey: SaveStatusKey }>('span', ({ $theme, $statusKey }) => {
  const { background, color } = toneOf($theme, $statusKey)

  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    height: '30px',
    paddingLeft: '10px',
    paddingRight: '12px',
    borderTopLeftRadius: '15px',
    borderTopRightRadius: '15px',
    borderBottomLeftRadius: '15px',
    borderBottomRightRadius: '15px',
    backgroundColor: background,
    color,
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    transitionProperty: 'background-color, color',
    transitionDuration: '150ms',
    transitionTimingFunction: 'ease',
    '@media (prefers-reduced-motion: reduce)': { transitionDuration: '0ms' },
  }
})

export const StatusDot = styled('span', {
  width: '8px',
  height: '8px',
  borderTopLeftRadius: '50%',
  borderTopRightRadius: '50%',
  borderBottomLeftRadius: '50%',
  borderBottomRightRadius: '50%',
  backgroundColor: 'currentColor',
})
